module.exports = __webpack_public_path__ + "img/about-two-img-1.d6fa7e60.jpg";